import {
  cva,
  type VariantProps,
} from 'class-variance-authority'

import { cn } from '@/lib/utils'

import User from '../icons/user.svg'

const avatarVariants = cva(
  'inline-flex justify-center items-center rounded-full size-12 relative overflow-hidden',
  {
    variants: {
      size: {
        xs: 'size-6',
        sm: 'size-9',
        default: 'size-12',
        lg: 'size-32',
        xl: 'size-36',
      },
      fallback: {
        true: 'bg-neutral-600 p-2',
        false: '',
      },
      reflective: {
        true: null,
        false: null,
      },
    },
    defaultVariants: {
      size: 'default',
    },
  },
)

export interface AvatarProps {
  src?: string
  size?: VariantProps<typeof avatarVariants>['size']
  className?: string
}

export default function Avatar({
  src,
  size,
  className,
}: AvatarProps) {
  return (
    <div
      className={cn(avatarVariants({ className, fallback: !src, size }))}
    >
      {src ? (
        <img src={src} alt="avatar" className="size-full" />
      ) : (
        <User className="size-[80%] fill-neutral-500" />
      )}
    </div>
  )
}
